// Generated by Melange

import * as Ppx_deriving_json_runtime from "melange-json.ppx-runtime/ppx_deriving_json_runtime.jsx";
import * as Subsonic__Response from "./response.jsx";
import * as Subsonic__Song from "./song.jsx";

function topSongs_of_json(x) {
  if (!(typeof x === "object" && !Array.isArray(x) && x !== null)) {
    Ppx_deriving_json_runtime.of_json_error("expected a JSON object");
  }
  const v = x.song;
  return {
    song: v !== undefined ? Ppx_deriving_json_runtime.Primitives.option_of_json((function (param) {
        return Ppx_deriving_json_runtime.Primitives.array_of_json(Subsonic__Song.of_json, param);
      }), v) : undefined
  };
}

function topSongs_to_json(x) {
  return {
    song: Ppx_deriving_json_runtime.Primitives.option_to_json((function (param) {
      return Ppx_deriving_json_runtime.Primitives.array_to_json(Subsonic__Song.to_json, param);
    }), x.song)
  };
}

function body_of_json(x) {
  if (!(typeof x === "object" && !Array.isArray(x) && x !== null)) {
    Ppx_deriving_json_runtime.of_json_error("expected a JSON object");
  }
  const v = x.status;
  let tmp;
  if (v !== undefined) {
    const tag = Ppx_deriving_json_runtime.Primitives.string_of_json(v);
    tmp = tag === "ok" ? "ok" : Ppx_deriving_json_runtime.of_json_error("invalid JSON");
  } else {
    tmp = Ppx_deriving_json_runtime.of_json_error("missing field \"status\"");
  }
  const v$1 = x.topSongs;
  return {
    status: tmp,
    topSongs: v$1 !== undefined ? topSongs_of_json(v$1) : Ppx_deriving_json_runtime.of_json_error("missing field \"topSongs\"")
  };
}

function body_to_json(x) {
  return {
    status: "ok",
    topSongs: topSongs_to_json(x.topSongs)
  };
}

function of_json(x) {
  return Subsonic__Response.of_json(body_of_json, x);
}

function to_json(x) {
  return Subsonic__Response.to_json(body_to_json, x);
}

export {
  topSongs_of_json,
  topSongs_to_json,
  body_of_json,
  body_to_json,
  of_json,
  to_json,
}
/* No side effect */
